<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import { getLanguage } from '@/helpers/language-helper'
import { getCookie } from '@/utils/utils'

const route = useRoute()
const isDismissed = ref(false)
const STORAGE_KEY = 'hantec_brazil_geoip_sticky_notice_closed'

const currentLanguage = computed(() => {
  const routeLang = route.params.lang
  if (typeof routeLang === 'string' && routeLang) {
    return routeLang
  }

  return getLanguage() || 'en'
})

const isEnglish = computed(() => currentLanguage.value === 'en')
const cookieCountry = computed(() => (getCookie('country') || '').toUpperCase())
const isVisible = computed(() => cookieCountry.value === 'BR' && !isDismissed.value)

const copy = computed(() => {
  if (isEnglish.value) {
    return {
      title: 'Important',
      body: `We are undergoing regulatory adjustments and, in compliance with local   
regulations, we inform you that this website is operated internationally by   
Hantec Markets Holdings Limited. As the Hantec Group operates overseas, we   
are not authorized by the CVM or Bacen to offer or broker securities in Brazil. By   
accessing this website, you acknowledge our global operations and agree to   
these conditions.`
    }
  }

  return {
    title: 'Importante',
    body: `Estamos passando por adequações regulatórias e, em observância à normas   
locais, informamos que este site é operado internacionalmente pela Hantec   
Markets Holdings Limited. Como o Hantec Group atua no exterior, não   
possuímos autorização da CVM ou do Bacen para ofertar ou intermediar   
valores mobiliários no Brasil. Ao acessar, você declara ciência de nossa atuação   
global e concorda com estas condições.`
  }
})

const closeNotice = () => {
  isDismissed.value = true
  sessionStorage.setItem(STORAGE_KEY, 'true')
}

onMounted(() => {
  if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
    isDismissed.value = true
  }
})
</script>

<template>
  <div
    v-if="isVisible"
    class="fixed bottom-2 left-2 z-[900] max-w-[290px] md:max-w-[320px] bg-[#2b2b2b] border border-black shadow-[0_10px_30px_rgba(0,0,0,0.35)] p-[1rem]"
  >
    <button
      @click="closeNotice"
      class="absolute top-3 right-3 text-white text-[34px] leading-none h-8 w-8 flex items-center justify-center"
      aria-label="Close notice"
      type="button"
    >
      ×
    </button>
    <p class="text-white hint !text-xs !font-bold mb-2.5">
      {{ copy.title }}
    </p>
    <p class="text-white hint !text-xs">
      {{ copy.body }}
    </p>
  </div>
</template>
